const roleIds = {
  salesHead: ["6780c49a0103dd208a38658d"],
  admin: ["6799c6552fbc2c922a8a6b8d"],
};

export default roleIds;
